import type { Menu } from './types';

export const WORKSPACE_GRID_COLUMNS = 4;

/**
 * 移动端工作台菜单节点，只保留已实现的移动端工作区入口。
 */
export interface WorkspaceMenu extends Omit<Menu, 'children'> {
  /** 子级工作台菜单。父级菜单不配置 path，通过 /workspace/:code 进入下级。 */
  children?: WorkspaceMenu[];
}

/**
 * 移动端工作台业务菜单。该默认导出也是移动端权限码 SDK 的生成来源。
 */
export default [
  {
    code: 'CAR_PURCHASE',
    label: '车源采购',
    children: [
      {
        code: 'CAR_PURCHASE_CONTRACT',
        label: '采购合同',
        path: '/car-purchase/purchase-contract',
      },
    ],
  },
  {
    code: 'DOMESTIC_TRADE',
    label: '内贸过票',
    children: [
      {
        code: 'DOMESTIC_TRADE_CONTRACT',
        label: '内贸采购合同',
        path: '/domestic-trade/purchase-contract',
      },
      {
        code: 'DOMESTIC_TRADE_SALES_CONTRACT',
        label: '内贸销售合同',
        path: '/domestic-trade/sales-contract',
      },
    ],
  },
  {
    code: 'FOREIGN_TRADE',
    label: '外贸销售',
    children: [
      {
        code: 'FOREIGN_TRADE_SALES_CONTRACT',
        label: '外贸销售合同',
        path: '/foreign-trade/sales-contract',
      },
      {
        code: 'FOREIGN_TRADE_CONTRACT',
        label: '外贸采购合同',
        path: '/foreign-trade/purchase-contract',
      },
      {
        code: 'FOREIGN_TRADE_QUOTE_CALCULATOR',
        label: '报价计算器',
        path: '/foreign-trade/quote-calculator',
      },
    ],
  },
] satisfies WorkspaceMenu[];
